import React, { useState } from "react";

// APP COMPONENTS
import { platformsFrame } from "../../common/frames";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const PlatformFilter = ({ selectedValue, onFilterChange }) => {
  const [platforms, setPlatforms] = useState(platformsFrame);

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="platforms-values"
      options={platforms}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Plataformas"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

PlatformFilter.displayName = "Plataforma";

export default PlatformFilter;
